import { get, post } from '@/helpers/HttpHelper'
import qs from 'qs'

export class ProductoService {
  async getProductos (params) {
    const queryString = qs.stringify(params, { arrayFormat: 'brackets' })
    const response = await get(`/productos?${queryString}`)
    return response.data
  }

  async getSearchProductos (params) {
    const queryString = qs.stringify(params)
    const response = await get(`/buscar_productos?${queryString}`)
    return response.data.data
  }

  async getDetalleProducto (productoId) {
    const response = await get(`detalle_producto?codigo=${productoId}`)
    return response.data.data
  }

  async getProductosMasVendido () {
    const response = await get('/productos_mas_vendidos')
    return response.data.data
  }

  async getProductosSimilares (formData) {
    const response = await post('/productos_similares', formData)
    return response.data.data
  }

  async getProductosComplementarios (formData) {
    const response = await post('/productos_complementarios', formData)
    return response.data.data
  }

  async cargarImagenes (formData) {
    const response = await post('/admin/productos/cargar_imagenes', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getTransportistas (ubigeo) {
    const response = await get('/transportistas/' + ubigeo)
    return response.data.data
  }

  async getTransportistaLocales (codTransportista, ubigeo) {
    const response = await get(`/local_transportista/${codTransportista}/${ubigeo}`)
    return response.data.data
  }

  async getClienteDirecciones () {
    const response = await get('/cliente/direcciones')
    return response.data.data
  }

  async generarOrden (dataOrden) {
    const response = await post('/productos/generar_orden', dataOrden)
    return response.data
  }

  async cotizarAsesor (formData) {
    const response = await post('/productos/solicitud_producto_pedido', formData)
    return response.data.data
  }

  async getPreciosDelivery (formData) {
    const response = await post('/precios_delivery', formData)
    return response.data.data
  }

  async getClienteLineaCredito (formData) {
    const response = await post('/cliente/linea_credito', formData)
    return response.data.data
  }

  async getCortes (productoId, cantidad) {
    const response = await get(`tramos_fibra?codigo=${productoId}&cantidad=${cantidad}`)
    return response.data.data
  }

  async getProductosComparar (formData) {
    const response = await post('/comparar_productos', formData)
    return response.data.data
  }

  async validarStock (formData) {
    const response = await post('/validar_stock', formData)
    return response.data
  }
}
